"use client";
import { FormEvent, useState } from "react";
import { CgSpinnerTwoAlt } from "react-icons/cg";

export default function Page() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setEmail("");
    await fetch("/api/password-forgot", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
      }),
    });
    setMessage(
      "Wenn die E-Mail in unserem System ist, dann haben wir dir eine Mail gesendet. Schau bitte unbeningt auch im Spamfilter."
    );
    setLoading(false);
  };

  return (
    <section className="bg-white h-full">
      <div className="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 z-10 relative h-full">
        <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">
          Passwort vergessen?
        </h1>
        <p className="mb-8 text-lg font-normal text-gray-500 lg:text-xl sm:px-16 lg:px-48 dark:text-gray-200">
          Wir schicken dir eine E-Mail mit Anweisungen zum Zurücksetzen deines
          Passworts.
        </p>
        {message.length ? (
          <div className="fixed top-0 left-0 z-50 flex justify-between w-full p-4 border-b border-gray-200 bg-gray-50 dark:bg-gray-700 dark:border-gray-600">
            <div className="flex items-center mx-auto">
              <p className="flex items-center text-sm font-normal text-gray-500 dark:text-gray-400">
                <span>{message}</span>
              </p>
            </div>
          </div>
        ) : null}
        <form className="w-full max-w-md mx-auto" onSubmit={handleSubmit}>
          <label
            htmlFor="default-email"
            className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
          >
            Email sign-up
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                className="w-5 h-5 text-gray-500 dark:text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
              </svg>
            </div>
            <input
              type="email"
              id="default-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-green-500 focus:border-green-500 dark:bg-gray-800 dark:border-gray-700 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
              placeholder="dein@mail.addresse"
              required
            />
            <button
              type="submit"
              disabled={loading}
              className="flex items-center  text-white absolute right-2.5 bottom-2.5 bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
            >
              {loading ? (
                <>
                  <CgSpinnerTwoAlt className="spin mr-2" />
                  <span>wird gesendet</span>
                </>
              ) : (
                <span>Absenden</span>
              )}
            </button>
          </div>
        </form>
      </div>
      <div className="w-full h-full absolute top-0 left-0 z-0"></div>
    </section>
  );
}
